module.exports = __webpack_public_path__ + "img/icon_work.764b2ca6.png";